import clsx from "clsx";

import { AccommodationFacilityType } from "../../../../../__generated__/gql/graphql";

import { useAccommodationFilterContext } from "./accommodation-filter-context";

type SuggestFilter =
  | { label: string; type: "facility"; key: AccommodationFacilityType }
  | { label: string; type: "area"; key: string };

const SUGGEST_FILTERS: SuggestFilter[] = [
  { label: "サウナ", type: "facility", key: AccommodationFacilityType.Sauna },
  {
    label: "ドッグフレンドリー",
    type: "facility",
    key: AccommodationFacilityType.DogFriendly,
  },
  { label: "軽井沢", type: "area", key: "karuizawa" },
  { label: "八ヶ岳", type: "area", key: "yatsugatake" },
];

export function FilterBar() {
  const {
    openFilterModal,
    hasAnyActiveFilter,
    activeFilters,
    addAreaFilter,
    addFacilityFilter,
  } = useAccommodationFilterContext();

  function handleSuggestClick(suggest: SuggestFilter) {
    if (suggest.type === "area") {
      addAreaFilter(suggest.key);
    } else {
      addFacilityFilter(suggest.key);
    }
  }

  return (
    <div className="border-skogecha/10 bg-slightbeige flex items-center border-t border-b py-[8px] pl-[16px]">
      {/* 絞り込みボタン */}
      <button
        data-analytics-id="reservation_calendar_opened_filters"
        type="button"
        onClick={openFilterModal}
        className={clsx(
          "flex shrink-0 items-center justify-center gap-[4px] rounded-full border px-[12px]",
          "h-[32px]",
          "border-skogecha bg-swhite",
          "text-xs font-medium",
          "hover:cursor-pointer hover:opacity-70",
        )}
      >
        <FilterIcon
          className={clsx(
            "size-[16px] shrink-0",
            hasAnyActiveFilter ? "text-sorange" : "text-skogecha",
          )}
        />
        {!hasAnyActiveFilter && (
          <span className="text-skogecha-100 whitespace-nowrap">
            条件で絞り込み
          </span>
        )}
      </button>

      <div className="flex min-w-0 items-center gap-[8px] overflow-x-auto pr-[16px] pl-[8px]">
        {hasAnyActiveFilter ? (
          <>
            {activeFilters.map((filter) => (
              <span
                key={`${filter.type}-${filter.value}`}
                className="bg-slightbeige-108 border-slightbeige-108 text-skogecha-100 font-notojp flex shrink-0 items-center gap-[4px] rounded-full border px-[8px] py-[8px] text-[10px] leading-none font-bold"
              >
                {filter.label}
                <button
                  data-analytics-id="reservation_calendar_dismissed_filter"
                  type="button"
                  onClick={filter.onRemove}
                  className="hover:opacity-70"
                  aria-label={`${filter.label}を解除`}
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    className="shrink-0"
                  >
                    <path
                      d="M9 3L3 9M3 3L9 9"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </span>
            ))}
          </>
        ) : (
          <>
            {SUGGEST_FILTERS.map((suggest) => (
              <button
                data-analytics-id="reservation_calendar_selected_suggested_filter"
                key={suggest.key}
                type="button"
                onClick={() => handleSuggestClick(suggest)}
                className="font-notojp text-skogecha-100 shrink-0 px-[4px] py-[8px] text-[12px] leading-none underline hover:opacity-70"
              >
                {suggest.label}
              </button>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

function FilterIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M21 4H14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12H12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 20H16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2V6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10V14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 18V22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
